import { render, staticRenderFns } from "./PaymentGateways.vue?vue&type=template&id=2b467d49&"
import script from "./PaymentGateways.vue?vue&type=script&lang=ts&"
export * from "./PaymentGateways.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentGateways.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports